import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Download = () => {
  return (
    <div className={styles.root}>Hello, I am Download</div>
  )
}

Download.propTypes = {}

export default Download
